import { useRef, useEffect, useState } from "react";
import { ChevronDown, Check } from "lucide-react";

// Compact single-select dropdown. The trigger always shows a fixed label ("Sort")
// so the box stays small regardless of the chosen option. Closes on outside click.
export default function SortSelect({ label = "Sort", options, value, onChange, testid, width = "w-56" }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);

  return (
    <div className="relative" ref={ref}>
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        data-testid={testid}
        className="inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.15em] px-4 py-2.5 border border-line text-vellum-muted hover:text-vellum hover:border-vellum-muted transition-colors"
      >
        {label}
        <ChevronDown className={`w-3.5 h-3.5 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div data-testid={`${testid}-panel`} data-lenis-prevent className={`absolute z-50 mt-2 ${width} max-h-72 overflow-y-auto overscroll-contain bg-ink-800 border border-line shadow-2xl p-1`}>
          {options.map((o) => {
            const on = value === o.key;
            return (
              <button
                key={o.key}
                type="button"
                onClick={() => { onChange(o.key); setOpen(false); }}
                data-testid={`${testid}-opt-${o.key}`}
                className="w-full flex items-center gap-2.5 px-3 py-2 text-left font-sans text-sm text-vellum hover:bg-ink-700 transition-colors"
              >
                <span className={`w-4 h-4 border rounded-full flex items-center justify-center shrink-0 ${on ? "bg-crimson border-crimson" : "border-line"}`}>
                  {on && <Check className="w-3 h-3 text-onaccent" />}
                </span>
                {o.label}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
